import { useState, useMemo, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { links } from "../../../constants/links";
import { getUserInfo } from "../../../services/ads/ads.service";

export const useSmartRetailStatus = () => {
    const location = useLocation();
    const { t } = useTranslation();
    const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
    const merchantReference = searchParams.get("merchant_reference") || "";
    const subCampaignId = searchParams.get("subcampaign_id");
    const isNonVendingPayGetCoupon: boolean = (searchParams.get("is_non_vending_pay_get_coupon"))?.toLowerCase() === "true";
    const has_coupon_config: boolean = (searchParams.get("has_coupon_config"))?.toLowerCase() === "true";
    const sessionId = localStorage.getItem("session-id");
    const engageSession = localStorage.getItem("engage-session-id") || "";
    const [isFadeLoading, setFadeLoading] = useState<boolean>(false);
    const [dispenseStatuskey, setDispenseStatusKey] = useState("productShallBeDispensed")
    const navigate = useNavigate();

    useEffect(() => {
        document.body.style.overflow = "hidden"; // Prevent body scrolling
        return () => {
            document.body.style.overflow = "auto"; // Reset when component unmounts
        };
    }, []);

    const navigateMain = () => {
        setTimeout(() => {
            if (merchantReference && subCampaignId) {
                setFadeLoading(true);
                setDispenseStatusKey("youShallBeRedirected");
                setTimeout(() => {
                    navigate(links.MAIN, {
                        state: {
                            "merchant_reference": merchantReference,
                            "subcampaign_id": subCampaignId,
                            "is_pay_get_coupon": true
                        }
                    });
                }, 1000);
            }
        }, 1000);
    };

    useEffect(() => {
        if (sessionId && subCampaignId) {

            getUserInfo({ subcampaign_id: subCampaignId }).then((data) => {
                localStorage.setItem("phone_number", data?.phone_number);
                localStorage.setItem("last_platform_type", data?.platform);
                const background = data?.background;
                const platform = (data?.platform || "").toLowerCase();
                let platformName = "";

                if (platform.includes("line")){
                    platformName = "line";
                } else if (platform.includes("whatsapp")){
                    platformName = "whatsapp";
                }

                if (isNonVendingPayGetCoupon){
                    if (engageSession && has_coupon_config){
                        navigate(
                            `${links.CAMPAIGN_STATUS.replace(":status", "success")}?platform=${platformName}`,
                            { state: { "background": background } }
                        );
                        return
                    }
                    setDispenseStatusKey("thankYouForThePayment");
                    return
                } else {
                    setDispenseStatusKey("productShallBeDispensed");
                    return navigateMain();
                }

            }).catch(() => {
                return navigateMain();
            });

        } else {
            if (isNonVendingPayGetCoupon){
                setDispenseStatusKey("thankYouForThePayment");
            }
            return navigateMain();
        }
    }, [t, merchantReference, subCampaignId, sessionId, navigate, isNonVendingPayGetCoupon, has_coupon_config]);

    return {
        t,
        isFadeLoading,
        dispenseStatusMessage: t(dispenseStatuskey),
    };
};
